module.exports = __webpack_public_path__ + "public/images/header-slide-3.e81f8de5a4d8bc24f5537d3c33c5458f.jpg";